// extracted by mini-css-extract-plugin
export default {"root":"VideoEditor_root__MlfYg","title":"VideoEditor_title__MqMEq","upload__btn":"VideoEditor_upload__btn__yQsNW","re__upload__btn":"VideoEditor_re__upload__btn__oVSAV"};